import Cookies from "js-cookie";

namespace Experiment {
  export type Name =
    | "solidCreditAccountActivation"
    | "solidCreditAccountDetails"
    | "signupPageV2Run2";

  export namespace Cookie {
    const prefix = "kikoff-experiment-";

    export const get = (name: Name) => Cookies.get(`${prefix}${name}`);
  }
}

export default Experiment;
